import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

export function DocumentRequirements() {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold mb-3">Document Requirements</h3>
        <ul className="list-disc list-inside space-y-2 text-muted-foreground">
          <li>Payment summaries or income statements</li>
          <li>Investment income statements</li>
          <li>Rental property documents</li>
          <li>Any other relevant income documentation</li>
        </ul>
      </div>

      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          Please ensure all uploaded documents are clear and legible. Your documents are stored securely and can only be accessed by you and our tax agents.
        </AlertDescription>
      </Alert>
    </div>
  );
}